goog.provide('el8.app.settings.util');

el8.app.settings.util = (function() {

    return {

        handleSavedMsg: function($elt) {
            var $msg;
            if ($elt.hasClass('confirm-msg')) {
                $msg = $elt;
            } else {
                $msg = $elt.parent().parent().find('.confirm-msg'); // go up max two levels
            }
            $msg.text('Saved');
            $.el8_setTimeout(function() {
                $msg.empty();
            }, 2*1000);
        }

    };

})();
